<mat-form-field class="fs-next w-100">
  <mat-select (selectionChange)="onMenuSelected($event)" [value]="selectedItem">
    <mat-option *ngFor="let tab of menu" [value]="tab.value">
      <p class="fsn-body-medium">{{ tab.name }}</p>
    </mat-option>
  </mat-select>
</mat-form-field>
